/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const challengeVsPairV2Schema = z.object({
  aSlug: z.string(),
  bSlug: z.string(),
  updatedAt: z.number(),
  locales: z.array(z.string()),
});

export type IChallengeVsPairV2 = z.infer<typeof challengeVsPairV2Schema>;

export const listPublicChallengeVsV2ResultSchema = z.object({
  items: z.array(challengeVsPairV2Schema),
  nextCursor: z.string().nullable(),
});

export type IListPublicChallengeVsV2Result = z.infer<typeof listPublicChallengeVsV2ResultSchema>;

export const listPublicChallengeVsV2ResponseSchema = createApiResponseSchema(
  listPublicChallengeVsV2ResultSchema,
) as z.ZodSchema<IAPI<IListPublicChallengeVsV2Result>>;

export type IListPublicChallengeVsV2Response = IAPI<IListPublicChallengeVsV2Result>;
